import { homeData } from '@/mocks/home';

export default function TimelineSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            人生时间线
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto">
            从1983年到今天，苍井空人生中的重要时刻
          </p>
          <div className="mt-4 w-12 h-0.5 bg-primary-500 mx-auto"></div>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 md:-translate-x-px"></div>

          <div className="flex flex-col gap-8">
            {homeData.timeline.map((item, index) => (
              <div
                key={item.year}
                className={`relative flex items-start gap-6 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                  <div className="md:hidden absolute left-4 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 z-10"></div>
                  <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-500 bg-primary-100/70 rounded-full mb-2">
                    {item.year}
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>

                <div className="hidden md:flex absolute left-1/2 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 z-10"></div>

                <div className="hidden md:block flex-1"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}